// extracted by mini-css-extract-plugin
module.exports = {"cardwrapper":"card-module--cardwrapper--1IyiU","cardBackground":"card-module--cardBackground--2BvDw","cardwrapperSelectedBorder":"card-module--cardwrapperSelectedBorder--HdTKc"};